import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { NavigationEnd, Router } from '@angular/router'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { sideNavItems } from '@modules/navigation/data/side-nav-dashboard.data'
import { filter, map, startWith } from 'rxjs/operators'

export interface BottomNavItem {
	label: string
	icon: IconProp
	link: string
	/** Prefixo de rota que mantém a aba ativa (Minha Conta tem Perfil e Segurança). */
	activePrefix: string
}

/**
 * As abas do app do signatário (spec 058). Rótulos e ícones das duas primeiras saem do menu lateral, para os dois
 * menus não divergirem.
 */
export const BOTTOM_NAV_ITEMS: BottomNavItem[] = [
	{ label: sideNavItems['sig'].text, icon: ['fas', 'file-signature'], link: '/signer/board', activePrefix: '/signer/board' },
	{ label: sideNavItems['signerResponsible'].text, icon: ['fas', 'building-user'], link: '/signer/responsible', activePrefix: '/signer/responsible' },
	{ label: 'Minha Conta', icon: ['far', 'circle-user'], link: '/account/profile/detail', activePrefix: '/account' }
]

@Component({
	selector: 'sb-bottom-nav',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './bottom-nav.component.html',
	styleUrls: ['bottom-nav.component.scss'],
	standalone: false
})
export class BottomNavComponent {
	private readonly router = inject(Router)

	readonly items = BOTTOM_NAV_ITEMS

	private readonly currentUrl = toSignal(
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			map(event => (event as NavigationEnd).urlAfterRedirects),
			startWith(this.router.url)
		),
		{ initialValue: this.router.url }
	)

	isActive(item: BottomNavItem) {
		return (this.currentUrl() ?? '').startsWith(item.activePrefix)
	}
}
